<template>
  <div>
    <div>
      <label>Main topic</label>
      <BaseTextarea
        type="text"
        placeholder="es. scoperta delle tradizioni artigianali alpine attraverso borghi e mercatini locali"
        v-model="form.title"
      />
    </div>

    <div class="mt-2">
      <label>Keyword SEO</label>
      <div class="input_with_btn">
        <BaseInput
          class="flex-grow-1"
          type="text"
          placeholder="es. lingua cimbra, laghi alpini, rifugi di montagna"
          v-model="newKeyword"
          @keyup.enter="addKeyword"
        />
        <button
          class="btn__search"
          type="button"
          @click="addKeyword"
          :disabled="!newKeyword.trim()"
        >
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
      <div class="pb-3 mt-2">
        <div class="bulk-file-list d-flex flex-wrap">
          <div
            class="seo_article__keyword mr-2 mb-2"
            v-for="(keyword, index) in form.seo_keywords"
            :key="index"
          >
            <p class="mb-0 seo_article__p">
              {{ keyword }}
              <i
                @click.prevent="removeKeyword(keyword)"
                class="fa-regular fa-xmark seo_article__asterisk"
              ></i>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label>{{ $t('length.title') }}</label>
        <el-select
          :popper-append-to-body="false"
          class="select-primary"
          size="medium"
          v-model="form.article_len"
        >
          <el-option
            v-for="length in lengths"
            class="select-primary"
            :value="length.value"
            :label="length.name"
            :key="length.value"
          />
        </el-select>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <BaseInput
          label="Target"
          type="text"
          placeholder="Target"
          v-model="form.target"
        />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <label for="customer_journey_sidebar">Customer Journey</label>
        <el-select
          v-model="form.customer_journey"
          id="customer_journey_sidebar"
          filterable
          class="select-primary m-0"
          placeholder="Customer Journey"
        >
          <el-option value="awareness">Awareness</el-option>
          <el-option value="interest">Interest</el-option>
          <el-option value="consideration">Consideration</el-option>
        </el-select>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col d-flex align-items-center">
        <label class="mb-0 mr-2">Generate FAQs</label>
        <el-switch v-model="form.faqs" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <BrandVoicesSelect
          :brand-voice-selected="form.brand_voice_id || null"
          @change="form.brand_voice_id = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BaseInput, BaseTextarea } from 'src/components/index';
import { Select, Option, Switch } from 'element-ui';
import BrandVoicesSelect from 'src/pages/Tools/ToolsComponent/BrandVoicesSelect.vue';
import lengthData from 'src/jsonFiles/length.json';

export default {
  name: 'WebArticleInputsForm',
  components: {
    BaseInput,
    BaseTextarea,
    [Option.name]: Option,
    [Select.name]: Select,
    [Switch.name]: Switch,
    BrandVoicesSelect,
  },
  props: {
    jsonData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        title: this.jsonData?.title ?? '',
        seo_keywords: Array.isArray(this.jsonData?.seo_keywords ?? this.jsonData?.keyword)
          ? [...(this.jsonData.seo_keywords ?? this.jsonData.keyword)]
          : [],
        faqs: this.jsonData?.faqs ?? false,
        article_len: this.jsonData?.article_len
          ? Number(this.jsonData.article_len)
          : 500,
        target: this.jsonData?.target ?? '',
        customer_journey: this.jsonData?.customer_journey ?? '',
        translate_from: this.jsonData?.translate_from ?? 'it',
        brand_voice_id: this.jsonData?.brand_voice_id ?? '',
      },
      newKeyword: '',
      lengths: lengthData.length,
    };
  },
  watch: {
    jsonData: {
      handler(newVal) {
        if (!newVal) return;
        this.form.title = newVal.title ?? '';
        const kws = newVal.seo_keywords ?? newVal.keyword;
        this.form.seo_keywords = Array.isArray(kws) ? [...kws] : [];
        this.form.faqs = newVal.faqs ?? false;
        this.form.article_len = newVal.article_len
          ? Number(newVal.article_len)
          : 500;
        this.form.target = newVal.target ?? '';
        this.form.customer_journey = newVal.customer_journey ?? '';
        this.form.translate_from = newVal.translate_from ?? 'it';
        this.form.brand_voice_id = newVal.brand_voice_id ?? '';
      },
      deep: true,
    },
    form: {
      handler() {
        this.$emit('update:formData', { ...this.form });
      },
      deep: true,
    },
  },
  methods: {
    addKeyword() {
      const trimmed = this.newKeyword.trim();
      if (trimmed && !this.form.seo_keywords.includes(trimmed)) {
        this.form.seo_keywords.push(trimmed);
        this.newKeyword = '';
      }
    },
    removeKeyword(keywordToRemove) {
      this.form.seo_keywords = this.form.seo_keywords.filter(
        (kw) => kw !== keywordToRemove
      );
    },
  },
  mounted() {
    this.$emit('update:formData', { ...this.form });
  },
};
</script>
